import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.5 6L5.5 3M2.75001 3.25H2.75501M5.25001 5.75H5.25501M7.5 9.5V1.5C7.5 0.947715 7.05228 0.5 6.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V9.5L2.25 8.5L4 9.5L5.75 8.5L7.5 9.5ZM3 3.25C3 3.38807 2.88807 3.5 2.75 3.5C2.61193 3.5 2.5 3.38807 2.5 3.25C2.5 3.11193 2.61193 3 2.75 3C2.88807 3 3 3.11193 3 3.25ZM5.5 5.75C5.5 5.88807 5.38807 6 5.25 6C5.11193 6 5 5.88807 5 5.75C5 5.61193 5.11193 5.5 5.25 5.5C5.38807 5.5 5.5 5.61193 5.5 5.75Z" />
  </svg>
);
